import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=5bce3ca6&"
import script from "./Translation.vue?vue&type=script&lang=ts&"
export * from "./Translation.vue?vue&type=script&lang=ts&"
import style0 from "./Translation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports